<template>
	<v-container class="fill-height height-minus-navbar" fluid>
		<v-row align="start">
			<v-col sm="4" md="4" lg="3" xl="2" class="d-none d-sm-flex">
				<v-row>
					<v-col cols="12">
						<div class="title">Параметр</div>
						<v-select
							:items="parseAxisSelect"
							item-text="title"
							item-value="slug"
							v-model="activeAxis"
							@change="switchAxis"
						></v-select>
					</v-col>
					<v-col cols="12">
						<div class="title">Фильтр</div>
					</v-col>
					<v-col cols="12">
						<!--
							TODO: 
							— add sliders click event, add input fields: https://github.com/vuetifyjs/vuetify/blob/master/packages/docs/src/examples/sliders/simple/min-max.vue
							— add sliders middle spot
						-->
						<div class="subtitle-2">Complexity</div>
						<v-range-slider
							:min=rangeSlider.complexity.min
							:max=rangeSlider.complexity.max
							:step="1"
							v-model="dataFilters.complexity"
							:thumb-label="true"
							@end="applyFilterComplexity"
						>
							<template v-slot:prepend>
								<v-text-field
									v-model="dataFilters.complexity[0]"
									class="mt-0 pt-0"
									hide-details
									single-line
									type="number"
									style="width:40px; text-align:center"
								></v-text-field>
							</template>

							<template v-slot:append>
								<v-text-field
									v-model="dataFilters.complexity[1]"
									class="mt-0 pt-0"
									hide-details
									single-line
									type="number"
									style="width:40px; text-align:center"
								></v-text-field>
							</template>
						</v-range-slider>
					</v-col>
					<v-col cols="12">
						<div class="subtitle-2">Entropy</div>
						<v-range-slider
							:min=rangeSlider.entropy.min
							:max=rangeSlider.entropy.max
							:step="1"
							v-model="dataFilters.entropy"
							:thumb-label="true"
							@end="applyFilterLogic"
						>
							<template v-slot:prepend>
								<v-text-field
									v-model="dataFilters.entropy[0]"
									class="mt-0 pt-0"
									hide-details
									single-line
									type="number"
									style="width:40px; text-align:center"
								></v-text-field>
							</template>

							<template v-slot:append>
								<v-text-field
									v-model="dataFilters.entropy[1]"
									class="mt-0 pt-0"
									hide-details
									single-line
									type="number"
									style="width:40px; text-align:center"
								></v-text-field>
							</template>
						</v-range-slider>
					</v-col>
					<v-col cols="12" align="right">
						<v-btn @click="clearFilters" text color="grey darken-4">Сбросить</v-btn>
					</v-col>
				</v-row>
			</v-col>
			<v-col sm="12" md="8" lg="9" xl="10">
				<ECharts :options="chartOptions" @click="handleClick" ref="chart" />
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
// http://man.hubwiz.com/docset/ECharts.docset/Contents/Resources/Documents/en/tutorial.html
import ECharts from 'vue-echarts'
import 'echarts/lib/chart/line'
import 'echarts/lib/chart/scatter'
import 'echarts/lib/component/title';
import 'echarts/lib/component/dataZoom'
import 'echarts/lib/component/dataZoomInside'
import 'echarts/lib/component/dataZoomSlider'

export default {
	name:"Chart",
	props:{ data: { default:null } },
	components: { ECharts },
	data: () => ({
		dataFilters: { entropy:[0,0], complexity:[0,0] },
		rangeSlider: { entropy: { min:0, max:0 }, complexity: { min:0, max:0 } },
		activeAxis: 'sentences', chartIsLoading:true,
		chartOptions: {
			title: {
				text: "Complexity/Entropy размещение текста (?)",
				subtext: "v 0.55",
				left: "center",
				top: 'top'
			},
			xAxis: { name: "Entropy" },
			yAxis: { name: "Complexity" },
			dataset: {
				source: []
			},
			dataZoom: [
				{ type: 'slider', show: true, xAxisIndex: [0] },
				{ type: 'slider', show: true, yAxisIndex: [0], left: '90.03%' },
				{ type: 'inside', xAxisIndex: [0] },
				{ type: 'inside', yAxisIndex: [0] }
			],
			series:[],
			tooltip: {
				show: false
			},
		}
	}),
	computed: {
		parseAxisSelect(){
			let entryModel = Object.assign({}, this.data[0])
			Array('id', 'words_num', 'symbols_num', 'text_preview').forEach(key => delete entryModel[key])
			return Object.keys(entryModel).map(key => {
				entryModel[key]['slug'] = key
				return entryModel[key]
			})
		},
		parsedData(){
			let parsedData = []
			this.data.forEach(entry => {
				if(entry[this.activeAxis].entropy < this.rangeSlider.entropy.min)
					this.rangeSlider.entropy.min = this.dataFilters.entropy[0] = entry[this.activeAxis].entropy
				if(entry[this.activeAxis].entropy > this.rangeSlider.entropy.max)
					this.rangeSlider.entropy.max = this.dataFilters.entropy[1] = entry[this.activeAxis].entropy
				
				if(entry[this.activeAxis].complexity < this.rangeSlider.complexity.min)
					this.rangeSlider.complexity.min = this.dataFilters.complexity[0] = entry[this.activeAxis].complexity
				if(entry[this.activeAxis].complexity > this.rangeSlider.complexity.max)
					this.rangeSlider.complexity.max = this.dataFilters.complexity[1] = entry[this.activeAxis].complexity
				
				parsedData.push({ x:entry[this.activeAxis].entropy, y:entry[this.activeAxis].complexity, id:entry.id, symbols_num:entry.symbols_num, words_num:entry.words_num })

			})
			return parsedData
		}
	},
	created(){
		this.chartOptions.dataset.source = this.parsedData
		this.setChartTitle()
		this.createSeries()
	},
	mounted(){
	},
	methods: {
		createSeries(){
			let xMin = Number.MAX_SAFE_INTEGER,
				yMin = Number.MAX_SAFE_INTEGER,
				xMax = Number.MIN_SAFE_INTEGER,
				yMax = Number.MIN_SAFE_INTEGER;

			this.chartOptions.series = {
				type:'scatter',
				data: this.chartOptions.dataset.source.map(entry => {
					if(xMin > entry.x) xMin = entry.x
					if(yMin > entry.y) yMin = entry.y
					if(xMax < entry.x) xMax = entry.x
					if(yMax < entry.y) yMax = entry.y
					let defineColor = () => {
						if(entry.symbols_num < 5000){ return '#64B5F6'}
						else if(entry.symbols_num >= 5000 && entry.symbols_num < 15000){ return '#42A5F5'}
						else if(entry.symbols_num >= 25000 && entry.symbols_num < 35000){ return '#1E88E5'}
						else if(entry.symbols_num >= 35000 && entry.symbols_num < 45000){ return '#1976D2'}
						else if(entry.symbols_num >= 45000 && entry.symbols_num < 55000) return '#1565C0'
						return '#0D47A1'
					}
					return {
						value: [entry.x,entry.y],
						symbolSize: Math.pow(5, entry.words_num/8000) > 5 ? Math.pow(5, entry.words_num/8000) : 5,
						itemStyle:{
							color:defineColor()
						}
					}
				}),
			}
			this.chartOptions.xAxis.min = xMin
			this.chartOptions.yAxis.min = yMin
			this.chartOptions.xAxis.max = xMax
			this.chartOptions.yAxis.max = yMax
		},
		setChartTitle(){
			this.chartOptions.title.text = this.chartOptions.title.text.replace(/\((.+?)\)/g, `(${this.parseAxisSelect.find(option => option.slug == this.activeAxis).title})`)
		},
		switchAxis(){
			this.setChartTitle()
		},
		setDatasetSource(data){
			this.chartOptions.dataset.source = data
		},
		// TODO: combine filters cretereas
		applyFilterComplexity(fieldVal){
			let [min, max] = fieldVal
			this.setDatasetSource(this.parsedData.filter(entry => (entry.y >= min && entry.y <= max)))
			this.createSeries()
		},
		applyFilterLogic(fieldVal){
			let [min, max] = fieldVal
			this.setDatasetSource(this.parsedData.filter(entry => (entry.x >= min && entry.x <= max)))
			this.createSeries()
		},
		clearFilters(){
			this.dataFilters.entropy = [this.rangeSlider.entropy.min, this.rangeSlider.entropy.max]
			this.dataFilters.complexity = [this.rangeSlider.complexity.min, this.rangeSlider.complexity.max]
			this.setDatasetSource(this.parsedData)
			this.createSeries()
		},
		handleClick(e){
			this.$eventBus.$emit('scatter_click', this.parsedData[e.dataIndex].id)
		}
	},
	watch: {
		'data'(){
			this.setDatasetSource(this.parsedData)
			this.createSeries()
		},
		'activeAxis'(){
			this.setDatasetSource(this.parsedData)
			this.createSeries()
		}
	}
}
</script>

<style lang="scss">
	@import '~vuetify/src/styles/styles.sass';
	.echarts {
		width:100%; height:70vh; min-height:600px;
	
		.v-toolbar__title img {
			display:block; width:200px;
			@media #{map-get($display-breakpoints, 'xl-only')}{
				height:700
			}
		}	
	}
</style>